// map.js
import React, { useRef, useEffect, useState } from "react"

// map
import ReactMapGL, { Marker, FlyToInterpolator } from "react-map-gl"
import useSupercluster from "use-supercluster"

const MAPBOX_TOKEN = process.env.GATSBY_MBGL_WEB_TOKEN

const Map = ({ points }) => {
  const [viewport, setViewport] = useState({
    latitude: 20,
    longitude: -80,
    width: "fit",
    height: "55vh",
    zoom: 2,
    minZoom: 2,
    mapboxApiAccessToken: MAPBOX_TOKEN,
  })

  const [showPoint, setShowPoint] = useState(null)

  const mapRef = useRef(null)

  // get bounds
  const bounds = mapRef.current
    ? mapRef.current.getMap().getBounds().toArray().flat()
    : null

  // get clusters
  const { clusters, supercluster } = useSupercluster({
    points,
    zoom: viewport.zoom,
    bounds,
    options: {
      radius: 75,
      maxZoom: 20,
    },
  })

  useEffect(() => {}, [])

  return (
    <ReactMapGL
      {...viewport}
      onViewportChange={newViewport => {
        setViewport({ ...newViewport, width: "fit" })
      }}
      ref={mapRef}
      mapStyle="mapbox://styles/mapbox/outdoors-v11"
      className="relative border-8 border-lightGreen"
    >
      {clusters.map(cluster => {
        const [longitude, latitude] = cluster.geometry.coordinates
        cluster.properties.markerId = cluster.id + 2
        const {
          cluster: isCluster,
          point_count: pointCount,
          markerId,
        } = cluster.properties

        if (isCluster) {
          return (
            <Marker
              key={cluster.id}
              latitude={latitude}
              longitude={longitude}
              offsetLeft={-30}
              offsetTop={-40}
            >
              <button
                className="bg-green-700 text-2xl rounded-full font-bold text-white flex items-center justify-center cursor-pointer font-heading"
                style={{
                  width: `${40 + (pointCount / points.length) * 30}px`,
                  height: `${40 + (pointCount / points.length) * 30}px`,
                }}
                onClick={() => {
                  const expansionZoom = Math.min(
                    supercluster.getClusterExpansionZoom(cluster.id),
                    20
                  )

                  setViewport({
                    ...viewport,
                    latitude,
                    longitude,
                    zoom: expansionZoom,
                    transitionInterpolator: new FlyToInterpolator({
                      speed: 2,
                    }),
                    transitionDuration: "auto",
                  })
                }}
              >
                {pointCount}
              </button>
            </Marker>
          )
        }

        return (
          <div key={cluster.properties.id || markerId}>
            <Marker latitude={latitude} longitude={longitude}>
              <div
                aria-hidden="true"
                className="cursor-pointer transform duration-300 bg-white border-4 border-darkGreen h-4 w-4 z-10 hover:bg-darkGreen hover:scale-150"
                onClick={() => {
                  if (showPoint === cluster.properties.id) {
                    setShowPoint(null)
                  } else {
                    setShowPoint(cluster.properties.id)
                  }
                }}
                // onMouseLeave={() => {
                //   setShowPoint(null)
                // }}
              />
            </Marker>
            <div
              className={`absolute m-6 bg-white border-4 border-darkGreen p-2 z-20 opacity-0 transform duration-1000 ${
                showPoint === cluster.properties.id ? "opacity-100" : "hidden"
              }`}
            >
              <h3 className="heading text-base">{cluster.properties.name}</h3>
              <p className="body text-sm mt-1">{cluster.properties.service}</p>
              <p className="body text-sm mt-1">{cluster.properties.industry}</p>
              <p className="body text-sm mt-1">{cluster.properties.size}</p>
            </div>
          </div>
        )
      })}
    </ReactMapGL>
  )
}

export default Map
